import {Button, Col, Form, Icon, Input, Row, Select} from 'antd';
import TreeAreasComponent from './TreeAreasComponent';
import moment from 'moment/moment';
import NumberFormat from 'react-number-format';
import React from 'react';
import PropTypes from 'prop-types';
import { higherEducationLevels } from '../../../../../Helpers/AuxVariables';

const GradFormComponent = (props) => {
   const { data = {}, handleDelete, onSubmit, loading, action } = props;
   const { getFieldDecorator, setFieldsValue, validateFields } = props.form;

   const _onSubmit = () => {
      validateFields(async (error, values) => {
         if (error) return 0;

         if (action === 'edit') {
            values.id = data.id;
         }
         onSubmit(action, values);
      });
   };

   return (
      <Row style={{ backgroundColor: 'white' }} gutter={[8, 8]} className={'formRow'}>
         <div
            style={{ position: 'absolute', right: 16, cursor: 'pointer', zIndex: 1 }}
            onClick={() => props?.onClose()}
         >
            <Icon type="close" />
         </div>
         <Col xs={24} md={12} className={'formItem'}>
            <Form.Item style={{ marginBottom: 10 }}>
               <div className="resumeLabel">
                  <label>
                     <span>* </span>
                     Universidade
                     {getFieldDecorator(`university`, {
                        rules: [{ required: true, message: 'Universidade é obrigatório' }],
                        initialValue: data ? data.university || '' : '',
                     })(
                        <Input
                           placeholder={'Nome da Universidade'}
                           maxLength={200}
                           style={{ marginBottom: 5 }}
                           size={'large'}
                        />
                     )}
                  </label>
               </div>
            </Form.Item>

            {/*<div style={{minHeight: 15, marginTop: 5}}> <span style={{color: 'red', fontSize: 13}}> {getFieldsError().university} </span> </div>*/}
         </Col>
         <Col xs={24} md={12} className={'formItem'}>
            <Form.Item style={{ marginBottom: 10 }}>
               <div className="resumeLabel">
                  <label>
                     <span>* </span>
                     Curso
                  </label>
                  {getFieldDecorator(`course`, {
                     rules: [{ required: true, message: 'Curso é obrigatório' }],
                     initialValue: data ? data.course || '' : '',
                  })(
                     <Input
                        placeholder={'Curso realizado'}
                        maxLength={100}
                        style={{ marginBottom: 5 }}
                        size={'large'}
                     />
                  )}
               </div>
            </Form.Item>

            {/*<div style={{minHeight: 15, marginTop: 5}}> <span style={{color: 'red', fontSize: 13}}> {getFieldsError().course} </span> </div>*/}
         </Col>
         <Col xs={24} className={'formItem'}>
            <Form.Item style={{ marginBottom: 10 }}>
               <div style={{ marginBottom: 5 }}>
                  <label>
                     <span style={{ color: '#D1392FFF' }}> * </span>
                     Área
                     {getFieldDecorator(`code`, {
                        rules: [
                           {
                              required: true,
                              message: 'Grau acadêmico é obrigatório',
                           },
                        ],
                        initialValue: data ? data.code || undefined : undefined,
                     })(<div></div>)}
                  </label>
                  <TreeAreasComponent
                     onSelect={(e) => {
                        setFieldsValue({ code: e.length > 0 ? e[0].value : null });
                     }}
                     hasCode={Object.keys(data).length > 0}
                     code={[{ label: data?.label, code: data?.code }]}
                  />
               </div>
            </Form.Item>
            {/*<div style={{minHeight: 15, marginTop: 5}}> <span style={{color: 'red', fontSize: 13}}> {getFieldsError().academic_degree} </span> </div>*/}
         </Col>
         <Col xs={24} md={16} className={'formItem'}>
            <Form.Item style={{ marginBottom: 10 }}>
               <div>
                  <label>
                     <span style={{ color: '#D1392FFF' }}> * </span>
                     Grau acadêmico
                     {getFieldDecorator(`academic_degree`, {
                        rules: [
                           {
                              required: true,
                              message: 'Grau acadêmico é obrigatório',
                           },
                        ],
                        initialValue: data ? data.academic_degree || undefined : undefined,
                     })(
                        <Select
                           style={{ marginBottom: 5 }}
                           placeholder="Selecione o grau do curso"
                           size={'large'}
                        >
                           {higherEducationLevels.map((item, index) => (
                              <Select.Option key={index} value={item}>
                                 {item}
                              </Select.Option>
                           ))}
                        </Select>
                     )}
                  </label>
               </div>
            </Form.Item>
            {/*<div style={{minHeight: 15, marginTop: 5}}> <span style={{color: 'red', fontSize: 13}}> {getFieldsError().academic_degree} </span> </div>*/}
         </Col>
         <Col xs={12} md={4} className={'formItem'}>
            <Form.Item style={{ marginBottom: 10 }}>
               <div className="resumeLabel">
                  <label>
                     <span>* </span>
                     Início
                     {getFieldDecorator(`start_date`, {
                        rules: [{ required: true, message: 'Início é obrigatório' }],
                        initialValue:
                           data.start_date ?
                              moment(data.start_date, 'YYYY-MM').format('MM/YYYY') || undefined
                           :  undefined,
                     })(
                        <NumberFormat
                           type={'tel'}
                           style={{ marginBottom: 5, textAlign: 'center' }}
                           className={'ant-input ant-input-lg'}
                           format="##/####"
                           placeholder="Mês/Ano"
                        />
                     )}
                  </label>
               </div>
            </Form.Item>
            {/*<div style={{minHeight: 15, marginTop: 5}}> <span style={{color: 'red', fontSize: 13}}> {getFieldsError().start_date} </span> </div>*/}
         </Col>
         <Col xs={12} md={4} className={'formItem'}>
            <Form.Item style={{ marginBottom: 10 }}>
               <div className="resumeLabel">
                  <label>
                     Fim
                     {getFieldDecorator(`end_date`, {
                        rules: [],
                        initialValue:
                           data.end_date ?
                              moment(data.end_date, 'YYYY-MM').format('MM/YYYY') || undefined
                           :  undefined,
                     })(
                        <NumberFormat
                           type={'tel'}
                           style={{ textAlign: 'center' }}
                           className={'ant-input ant-input-lg'}
                           format="##/####"
                           placeholder="Mês/Ano"
                        />
                     )}
                  </label>
               </div>
            </Form.Item>
         </Col>

         <Col
            style={{ alignItems: 'flex-end', paddingBottom: 0, marginTop: 5 }}
            className={'listButtons'}
            span={24}
         >
            {!data.id && (
               <Button
                  loading={loading}
                  disabled={loading}
                  className={'ant-btn-secondary'}
                  onClick={() => _onSubmit()}
               >
                  Salvar
               </Button>
            )}
            {data.id && (
               <>
                  <Button
                     loading={loading}
                     disabled={loading}
                     className={'ant-btn-secondary editButton'}
                     onClick={() => _onSubmit()}
                     style={{ minWidth: 100 }}
                  >
                     Editar
                  </Button>
                  <Button
                     loading={loading}
                     disabled={loading}
                     className={'ant-btn-red'}
                     onClick={() => handleDelete(data.id)}
                  >
                     Remover
                  </Button>
               </>
            )}
         </Col>
      </Row>
   );
};

GradFormComponent.propTypes = {
   action: PropTypes.oneOf(['add', 'edit']),
   handleDelete: PropTypes.func.isRequired,
   onSubmit: PropTypes.func.isRequired,
   onClose: PropTypes.func.isRequired,
};

export default Form.create({ name: 'gradsForm' })(GradFormComponent);
